"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType;
(function (MessageType) {
    MessageType["Mounted"] = "mounted";
    MessageType["Success"] = "success";
    MessageType["Fail"] = "fail";
    MessageType["OrderStatus"] = "orderStatus";
    MessageType["Error"] = "error";
    MessageType["Resize"] = "resize";
    MessageType["Redirect"] = "formRedirect";
    MessageType["Verify"] = "verify";
    MessageType["Interaction"] = "interaction";
    MessageType["Submit"] = "submit";
    MessageType["CustomStylesAppended"] = "customStylesAppended";
    MessageType["Card"] = "card";
    MessageType["PaymentDetails"] = "paymentDetails";
})(MessageType || (MessageType = {}));
exports.default = MessageType;
